import { render } from "./SaidaVisitante.vue?vue&type=template&id=4a9e8072&scoped=true"
import script from "./SaidaVisitante.vue?vue&type=script&lang=js"
export * from "./SaidaVisitante.vue?vue&type=script&lang=js"

import "./SaidaVisitante.vue?vue&type=style&index=0&id=4a9e8072&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9e8072"]])

export default __exports__